<app-stages [stages]="stages" currentStage="Oświadczenia"></app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)='submitAndGoNext()'>
    <fieldset>
      <legend>
        Oświadczenie
      </legend>
      <br>
      <div class="row">
        @if (form.invalid && form.touched) {
          <div class="col-md-6">
            <app-alert type="danger" [closable]="false" alertTittle="Uwaga!">
              Wybierz jedną z poniższych opcji!
            </app-alert>
          </div>
        }
        <div class="col-12">
          <p>Oświadczam że posiadam:</p>
          <br>
          <div class="form-group">
            <div class="custom-radio">
              <input
                name="objectPlacementStatementType"
                formControlName="objectPlacementStatementType"
                type="radio"
                id="a_radio"
                value="A) ważne pozwolenie na budowę obiektu umieszczanego w pasie drogowym">
              <label for="a_radio">
                <strong>A)</strong>
                ważne pozwolenie na budowę obiektu umieszczanego w pasie drogowym</label>
            </div>
            <div class="custom-radio">
              <input
                name="objectPlacementStatementType"
                formControlName="objectPlacementStatementType"
                type="radio"
                id="b_radio"
                value="B) zgłoszenie budowy lub prowadzonych robót właściwemu organowi administracji architektoniczno-budowlanej">
              <label for="b_radio">
                <strong>B)</strong>
                zgłoszenie budowy lub prowadzonych robót właściwemu organowi administracji architektoniczno-budowlanej
              </label>
            </div>
            <div class="custom-radio">
              <input
                name="objectPlacementStatementType"
                formControlName="objectPlacementStatementType"
                type="radio"
                id="c_radio"
                value="C) zamiar budowy przyłączy elektroenergetycznych, wodociągowych, kanalizacyjnych, gazowych, cieplnych i telekomunikacyjnych, dla których sporządzono plan sytuacyjny na kopii aktualnej mapy zasadniczej lub mapy jednostkowej przyjętej do państwowego zasobu geodezyjnego i kartograficznego">
              <label for="c_radio">
                <strong>C)</strong>
                zamiar budowy przyłączy elektroenergetycznych, wodociągowych, kanalizacyjnych, gazowych, cieplnych i
                telekomunikacyjnych, dla których sporządzono plan sytuacyjny na kopii aktualnej mapy zasadniczej lub
                mapy jednostkowej przyjętej do państwowego zasobu geodezyjnego i kartograficznego</label>
            </div>
          </div>
        </div>
      </div>
    </fieldset>
    <div class='application-actions'>
      <button
        type='button'
        class='btn btn-secondary'
        (click)='onCancel()'>
      <span>
        Wstecz
      </span>
      </button>
      <button
        type='button'
        class='btn btn-primary'
        (click)='submitAndGoNext()'>
        <span>Zapisz i przejdź dalej</span>
      </button>
    </div>
  </form>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
